import { createContext, useContext } from 'react'

export const DISABLE_BUY = true

export interface Settings {
  /** Submit deadline relative to now in seconds */
  submitDeadline: number
  /** Execution deadline relative to now in seconds */
  executionDeadline: number
  /** Gas price multiplier per mille */
  gasPriceMultiplier: number
  /** Slippage tolerance per mille */
  slippageTolerance: number
  /** Additional gas prepaid for execution */
  gasLimitOverpay: number
  gasPriceSpeed: number
  useWeth: boolean
  useSuggestedDeposit: boolean
  minRatioChange: number
  depositSlippageInBasisPoints: number
}

export const DEFAULT_SETTINGS: Settings = {
  submitDeadline: 24 * 60 * 60,
  executionDeadline: 24 * 60 * 60,
  gasPriceMultiplier: 1_050,
  slippageTolerance: 20,
  gasLimitOverpay: 20_000,
  gasPriceSpeed: 2,
  useWeth: false,
  useSuggestedDeposit: true,
  minRatioChange: 0,
  depositSlippageInBasisPoints: 500,
}

export const SettingsContext = createContext<{
  settings: Settings
  setSettings: (settings: Settings) => void
  restoreDefaults: () => void
}>(null as any)

export function useSettings() {
  return useContext(SettingsContext)
}
